// 开发工具

// 判断是否为开发环境
const NODE_ENV = process.env.NODE_ENV
const isDevelopment = NODE_ENV === 'development' || NODE_ENV === 'dev' ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost') ||
    (typeof window !== 'undefined' && window.location.hostname === '127.0.0.1')

// 重写 console 方法
// 生产环境下，将所有 console 方法替换为空函数
if (!isDevelopment) {
    console.log = () => { }
    console.warn = () => { }
    console.info = () => { }
    console.debug = () => { }
}